import { JavaScriptError } from '../errors/JavaScriptError';
import { LocalFileNotFoundFail } from '../fails/LocalFileNotFoundFail';
import { LocalFileNotReadableFail } from '../fails/LocalFileNotReadableFail';
import { EUploadReasonSource, UploadingReason } from '../serviceClasses/UploadingReason';

const SOURCE_WEB_CLIENT = EUploadReasonSource.SOURCE_WEB_CLIENT;

const wrapErrorWithOriginalStack = (original: DOMException | Error): Error => {
    const stack = new Error(original.message);
    if (original.stack) {
        stack.stack = original.stack;
    }
    return stack;
};

export const normalizeUploadError = (error: unknown): UploadingReason | null => {
    if (error == null) {
        return null;
    }

    if (error instanceof UploadingReason) {
        return error;
    }

    if (typeof DOMException !== 'undefined' && error instanceof DOMException) {
        const stack = wrapErrorWithOriginalStack(error);

        if (LocalFileNotFoundFail.isNotFoundError(error)) {
            return new LocalFileNotFoundFail(stack, SOURCE_WEB_CLIENT);
        }

        if (LocalFileNotReadableFail.isNotReadableError(error)) {
            return new LocalFileNotReadableFail(stack, SOURCE_WEB_CLIENT);
        }

        return new JavaScriptError(stack, SOURCE_WEB_CLIENT, error);
    }

    if (error instanceof Error) {
        return new JavaScriptError(error, SOURCE_WEB_CLIENT, error);
    }

    return new JavaScriptError(new Error(String(error)), SOURCE_WEB_CLIENT, null);
};
